import { ComposerBasePost } from './ComposerBasePost'

export const PINTEREST_AI_MODIFIED = 'AI_MODIFIED'
export const PINTEREST_AI_SYNTHETIC_PERFORMER = 'SYNTHETIC_PERFORMER'

export type PinterestAiContentMode = typeof PINTEREST_AI_MODIFIED | typeof PINTEREST_AI_SYNTHETIC_PERFORMER

export interface PinterestBoard {
  id: string
  name: string
  ppid: string
  url?: string
}

export interface ComposerPinterestPost extends ComposerBasePost {
  title: string
  description: string
  destinationUrl: string
  board?: PinterestBoard
  boards?: PinterestBoard[]
  aiContentMode?: PinterestAiContentMode
}
